import { DefaultTheme, css } from 'styled-components';
import { tenant } from '../config/tenant';

const { colors } = tenant;

export const MainTheme: DefaultTheme = {
	colors: {
		primary: {
			lighter: colors.primaryLighter,
			light: colors.primaryLight,
			medium: colors.primaryMedium,
		},
		body: {
			light: '#6B7588',
			medium: '#121212',
		},
		background: {
			light: '#f9f9f9',
		},
		neutral: {
			white: '#ffffff',
			black: colors.neutralBlack,
			lightGreen: 'rgba(14, 198, 198, 0.15)',
			green: '#06c270',
			blue: '#0063f7',
			lightRed: 'rgba(239, 29, 38, 0.15)',
			red: '#ff3b3b',
			yellow: colors.neutralYellow,
			grey: '#dee2e6',
		},
	},
	typography: {
		label: {
			small: css`
				font-family: 'Roboto';
				font-weight: 400;
				font-size: 14px;
			`,
			medium: css`
				font-family: 'Roboto';
				font-weight: 400;
				font-size: 16px;
			`,
		},
		headlines: {
			h1: css`
				font-family: 'Roboto';
				font-weight: 600;
			`,
			h2: css`
				font-family: 'Roboto';
				font-size: 44px;
				font-weight: 600;
			`,
			h3: css`
				font-family: 'Roboto';
				font-size: 28px;
				font-weight: 600;
			`,
			h4: css`
				font-family: 'Roboto';
				font-size: 24px;
				font-weight: 600;
			`,
			h5: css`
				font-family: 'Roboto';
				font-size: 20px;
				font-weight: 600;
			`,
			h6: css`
				font-family: 'Roboto';
				font-size: 16px;
				font-weight: 600;
			`,
		},
	},
	boxShadow: {
		primary: css`
			box-shadow: 0 0 40px 5px rgb(0 0 0 / 5%);
		`,
		dropdown: css`
			box-shadow: 0 16px 40px 5px rgb(0 0 0 / 20%);
		`,
	},
};

export const textFieldStyle = {
  /* ROOT */
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#fff",
    borderRadius: 2,
    transition: "all .2s ease",

    "& fieldset": {
      borderColor: "#d0d5dd", // borda neutra
    },

    /* HOVER */
    "&:hover fieldset": {
      borderColor: colors.primaryMedium,
    },

    /* FOCUS */
    "&.Mui-focused fieldset": {
      borderColor: colors.primaryMedium,
      borderWidth: "2px",
    },

    /* ERROR */
    "&.Mui-error fieldset": {
      borderColor: "#ff3b3b",
    },

    /* DISABLED */
    "&.Mui-disabled": {
      backgroundColor: "#f9f9f9",
    },
  },

  /* TEXTO */
  "& .MuiInputBase-input": {
    color: "#121212",
    fontSize: "0.95rem",
  },

  /* PLACEHOLDER */
  "& .MuiInputBase-input::placeholder": {
    color: "#9ca3af",
    opacity: 1,
  },

  /* LABEL */
  "& .MuiInputLabel-root": {
    color: "#6b7280",
    fontWeight: 500,
  },

  "& .MuiInputLabel-root.Mui-focused": {
    color: colors.primaryMedium,
  },

  "& .MuiInputLabel-root.Mui-error": {
    color: "#ff3b3b",
  },

  /* HELPER TEXT */
  "& .MuiFormHelperText-root": {
    marginLeft: 0,
    fontSize: "0.75rem",
    color: "#ff3b3b",
  },

  /* ÍCONE (Autocomplete) */
  "& .MuiIconButton-root": {
    color: colors.primaryMedium,
  },

  "& .MuiIconButton-root:hover": {
    backgroundColor: colors.accentSoft,
  },
};

export const cellStyle = {
  color: "#6B7588",
  fontSize: "0.85rem",
  fontWeight: 400,
  borderBottom: "1px solid rgba(40, 61, 107, 0.25)",
  verticalAlign: "middle",
};
export const cellStyleDestaque = {
  color: colors.accent,
  fontSize: "0.85rem",
  fontWeight: 600,
  borderBottom: "1px solid rgba(40, 61, 107, 0.25)",
};


export const colorCR5 =	"#8F8884";
export const colorCR0 =	"#F5F5F5";
export const colorPrimary = colors.accent;
export const colorBgNegative ="#fadbdb";
export const colorNegative ="#ff3b3b";
export const colorSubText ="#6B7588";
export const bordasComponents = "1px solid rgba(40, 61, 107, 0.4)"
export const colorPositive = "#06c270";